import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/ImageSearch";
import VerticalizedTable from "../components/verticalized_table";
import LinkButton from "../components/link_button";
import { CUSTOMER_HISTORIES } from "../const/mount_list";
import CustomerSearchForm from "../components/customer_search_form";
import Alert from "../components/alert";
import {
  fetchCustomerInfo,
  registerInherit,
  registerProhibit,
} from "../services/api";
import {
  displayInheritWording,
  displayProhibitWording,
} from "../const/alertWording";
import CustomSnackbar from "../components/custom_snackbar";
import {
  BRANCH_CODE,
  ACCOUNT_NUMBER,
  CIF_NUMBER,
  NAME_KANA,
  RECEIPT_NUMBEAR,
  ENTRY_STATUS,
  APP_STATUS,
  APP_STATUS_MEMO,
  PROHIBIT_STATUS,
  INHERIT_STATUS,
  INHERIT_AT,
  LOCK_STATUS,
  APPLICATIONIDS,
} from "../model/customer_info";

const styles = (theme) => ({
  cachedIcon: {
    fontSize: "20px",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(1500 + theme.spacing(3 * 2))]: {
      width: 1500,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  cardGrid: {
    padding: `${theme.spacing(8)}px 0`,
  },
  colorMain: {
    backgroundColor: "#01a32b",
    color: "#ffffff",
    "&:hover": {
      backgroundColor: "#33b555",
    },
  },
  replayIconMargin: {
    marginRight: "0.3em",
  },
  form: {
    marginTop: theme.spacing(1),
    marginLeft: "auto",
    marginRight: "auto",
  },
  linkbutton: {
    marginTop: theme.spacing(1),
    marginLeft: "auto",
    marginRight: "auto",
  },
  table: {
    marginTop: theme.spacing(2),
  },
  buttonArea: {
    marginTop: theme.spacing(2),
  },
});

class CustomerInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      snackMessage: null,
      branchCode: "",
      accountNumber: "",
      cifNumber: "",
      customerInfoData: {},
    };
    this.handleChangeBranchCode = this.handleChangeBranchCode.bind(this);
    this.handleChangeAccountNumber = this.handleChangeAccountNumber.bind(this);
    this.handleChangeCifNumber = this.handleChangeCifNumber.bind(this);
    this.viewErrorSnackBar = this.viewErrorSnackBar.bind(this);
    this.onErrorSnackbarClose = this.onErrorSnackbarClose.bind(this);
    this.viewSuccessSnackBar = this.viewSuccessSnackBar.bind(this);
    this.onSuccessSnackbarClose = this.onSuccessSnackbarClose.bind(this);
    this.clearCustomer = this.clearCustomer.bind(this);
    this.handleFetchInfo = this.handleFetchInfo.bind(this);
    this.registerInheritOnSubmit = this.registerInheritOnSubmit.bind(this);
    this.registerProhibitOnSubmit = this.registerProhibitOnSubmit.bind(this);
  }

  isInheritEnable(data) {
    let wordingStatus = null;
    switch (data) {
      case "引継未設定":
        wordingStatus = false;
        break;
      case "有効期限切れ":
        wordingStatus = true;
        break;
      case "引継設定中":
        wordingStatus = true;
        break;
      default:
        wordingStatus = data;
        break;
    }
    return wordingStatus;
  }

  setButtonMessage(data, wordTable) {
    if (
      data === undefined ||
      this.state.customerInfoData[APP_STATUS.key] === "未利用"
    )
      return wordTable[2];

    const selectedDisplayWording = wordTable[Number(data)];

    return selectedDisplayWording;
  }

  parseCustomerTable = (json) => {
    if (Object.keys(json).length < 1) return [];

    const tableInput = [
      {
        key: BRANCH_CODE.key,
        logicalName: BRANCH_CODE.logicalName,
        value: json[BRANCH_CODE.key],
        note: "",
      },
      {
        key: ACCOUNT_NUMBER.key,
        logicalName: ACCOUNT_NUMBER.logicalName,
        value: json[ACCOUNT_NUMBER.key],
        note: "",
      },
      {
        key: CIF_NUMBER.key,
        logicalName: CIF_NUMBER.logicalName,
        value: json[CIF_NUMBER.key],
        note: "",
      },
      {
        key: NAME_KANA.key,
        logicalName: NAME_KANA.logicalName,
        value: json[NAME_KANA.key],
        note: "※90日以上ログインしていない場合は「氏名取得不可」",
      },
      {
        key: APP_STATUS.key,
        logicalName: APP_STATUS.logicalName,
        value: json[APP_STATUS.key],
        note: json[APP_STATUS_MEMO.key],
      },
      {
        key: INHERIT_STATUS.key,
        logicalName: INHERIT_STATUS.logicalName,
        value: json[INHERIT_STATUS.key],
        note: "",
      },
      {
        key: INHERIT_AT.key,
        logicalName: INHERIT_AT.logicalName,
        value: json[INHERIT_AT.key],
        note: "",
      },
      {
        key: LOCK_STATUS.key,
        logicalName: LOCK_STATUS.logicalName,
        value: json[LOCK_STATUS.key],
        note: "※オフライン時のロックでは正しく表示されない可能性があります",
      },
      {
        key: "",
        logicalName: "即時口座開設状態",
        style: { backgroundColor: "#3f51b5", color: "#ffffff" },
      },
      {
        key: ENTRY_STATUS.key,
        logicalName: ENTRY_STATUS.logicalName,
        value: json[ENTRY_STATUS.key],
        note: "",
      },
      {
        key: RECEIPT_NUMBEAR.key,
        logicalName: RECEIPT_NUMBEAR.logicalName,
        value: json[RECEIPT_NUMBEAR.key],
        note: "",
      },
    ];
    return tableInput;
  };

  handleChangeBranchCode = (event) => {
    if (/^([0-9]{0,3})$/.test(event.target.value))
      this.setState({ branchCode: event.target.value });
  };
  handleChangeAccountNumber = (event) => {
    if (/^([0-9]{0,7})$/.test(event.target.value))
      this.setState({ accountNumber: event.target.value });
  };
  handleChangeCifNumber = (event) => {
    if (/^([0-9]{0,7})$/.test(event.target.value))
      this.setState({ cifNumber: event.target.value });
  };

  viewErrorSnackBar(mes) {
    this.setState({ snackMessage: mes });
  }
  onErrorSnackbarClose() {
    this.setState({ snackMessage: null });
  }

  viewSuccessSnackBar(mes) {
    this.setState({ successMessage: mes });
  }

  onSuccessSnackbarClose() {
    this.setState({ successMessage: null });
  }

  clearCustomer = () => {
    this.setState({ customerInfoData: [] });
  };

  handleFetchInfo = () => {
    if (!this.state.accountNumber && !this.state.cifNumber) {
      return this.viewErrorSnackBar(
        "口座番号かCIF番号はどちらかひとつを入力してください。"
      );
    }

    if (
      /^([a-zA-Z0-9]{0,2})$/.test(this.state.branchCode) ||
      /^([a-zA-Z0-9]{1,6})$/.test(this.state.accountNumber) ||
      /^([a-zA-Z0-9]{1,6})$/.test(this.state.cifNumber)
    )
      return this.viewErrorSnackBar(
        "店番号は3桁、口座番号またはCIF番号は7桁で入力してください。"
      );

    if (
      /^(?!1(01|02|03|04|05|06|07|08|09|10|11|12)).*$/.test(
        this.state.branchCode
      )
    ) {
      return this.viewErrorSnackBar("存在しない店番号が入力されています。");
    }
    this.clearCustomer();

    fetchCustomerInfo(
      this.state.branchCode,
      this.state.accountNumber,
      this.state.cifNumber
    ).done((json) => {
      if (json.view_message) return this.viewErrorSnackBar(json.view_message);
      if (json.error_code) {
        return this.viewErrorSnackBar(
          "該当する店番号・口座番号の顧客が見つかりません。"
        );
      }
      this.setState({ customerInfoData: json });
    });
  };

  componentDidMount() {
    this.props.setSubtitle("顧客情報検索画面");
  }

  registerInheritOnSubmit() {
    if (!this.state.customerInfoData) return;

    const param = {
      branchCode: this.state.customerInfoData.branch_code,
      accountNumber: this.state.customerInfoData.account_number,
      cifNumber: this.state.customerInfoData.cif_number,
      isInherit: !this.isInheritEnable(
        this.state.customerInfoData.is_inherited
      ),
    };

    registerInherit(param).then((response = {}) => {
      if (!Object.keys(response).length || response.system_message) {
        this.viewErrorSnackBar(
          response.view_message || "システムエラー 更新できませんでした。"
        );
        return;
      }
      this.viewSuccessSnackBar("更新に成功しました。");
      this.handleFetchInfo();
      return;
    });
  }

  registerProhibitOnSubmit() {
    if (!this.state.customerInfoData) return;

    const param = {
      branchCode: this.state.customerInfoData.branch_code,
      accountNumber: this.state.customerInfoData.account_number,
      cifNumber: this.state.customerInfoData.cif_number,
      isProhibit: !this.state.customerInfoData.is_prohibited,
    };

    registerProhibit(param).then((response = {}) => {
      if (!Object.keys(response).length || response.system_message) {
        this.viewErrorSnackBar(
          response.view_message || "システムエラー 更新できませんでした。"
        );
        return;
      }
      this.viewSuccessSnackBar("更新に成功しました。");
      this.handleFetchInfo();
      return;
    });
  }

  render() {
    const { classes, setMountTarget, setMountProps, updateParent } = this.props;
    const { snackMessage, successMessage, customerInfoData } = this.state;

    const viewAlertComponent = () => {
      const buttonList = [
        this.setButtonMessage(
          this.isInheritEnable(this.state.customerInfoData[INHERIT_STATUS.key]),
          displayInheritWording
        ),
        this.setButtonMessage(
          this.state.customerInfoData[PROHIBIT_STATUS.key],
          displayProhibitWording
        ),
      ];

      return buttonList.map((button) => {
        const isInherit = Object.hasOwnProperty.call(button, "inherit");
        const submitFunc = isInherit
          ? this.registerInheritOnSubmit
          : this.registerProhibitOnSubmit;

        return (
          <Alert
            classes="col-xs-3"
            icon={button.icon}
            title={button.title}
            description={button.description}
            submitText={button.submitText}
            submitFunc={submitFunc}
            disabled={
              !button.submitText
                ? true
                : isInherit && customerInfoData.is_prohibited
            }
          />
        );
      });
    };

    return (
      <React.Fragment>
        <main>
          <div className={classNames(classes.layout, classes.cardGrid)}>
            <CustomerSearchForm
              handleFetchInfo={this.handleFetchInfo}
              branchCode={this.state.branchCode}
              accountNumber={this.state.accountNumber}
              cifNumber={this.state.cifNumber}
              handleChangeBranchCode={this.handleChangeBranchCode}
              handleChangeAccountNumber={this.handleChangeAccountNumber}
              handleChangeCifNumber={this.handleChangeCifNumber}
            />
            <VerticalizedTable
              className={classes.table}
              tableInput={this.parseCustomerTable(customerInfoData)}
            />
            <div class="row" className={classes.buttonArea}>
              {viewAlertComponent()}
              <LinkButton
                classes="col-xs-3"
                icon={SearchIcon}
                setMountTarget={setMountTarget}
                setMountProps={setMountProps}
                updateParent={updateParent}
                link={CUSTOMER_HISTORIES}
                disabled={Object.keys(customerInfoData).length < 1}
                mountProps={() => {
                  return {
                    branchCode: customerInfoData[BRANCH_CODE.key],
                    accountNumber: customerInfoData[ACCOUNT_NUMBER.key],
                    cifNo: customerInfoData[CIF_NUMBER.key],
                    name: customerInfoData[NAME_KANA.key],
                    applicationids: customerInfoData[APPLICATIONIDS.key],
                  };
                }}
                text="顧客操作ログ"
              />
            </div>
          </div>
        </main>
        <CustomSnackbar
          snackMessage={snackMessage}
          onSnackbarClose={this.onErrorSnackbarClose}
        />
        <CustomSnackbar
          snackMessage={successMessage}
          onSnackbarClose={this.onSuccessSnackbarClose}
          snackType="SUCCESS"
        />
      </React.Fragment>
    );
  }
}

CustomerInfo.propTypes = {
  classes: PropTypes.object.isRequired,
  setMountTarget: PropTypes.func.isRequired,
  setMountProps: PropTypes.func.isRequired,
  updateParent: PropTypes.func.isRequired,
  setSubtitle: PropTypes.func.isRequired,
};

export default withStyles(styles)(CustomerInfo);
